module.exports = __webpack_public_path__ + "static/object-following-robot-e606c26ad7be35bde9ed3193c5a0a0ba.jpeg";